const styles = () => ({
  container: {
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    minHeight: 0,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    color: "#fff",
    padding: "clamp(0.35rem, 1.5vmin, 1.25rem)",
    overflow: "hidden"
  },
  message: {
    color: "#fff",
    fontFamily: "Oswald",
    lineHeight: 1.15,
    marginBottom: "14px",
    flex: "0 0 auto",
    width: "100%",
    textAlign: "center",
    fontSize: "2.8rem !important",
    "&&": {
      fontSize: "clamp(0.85rem, 2.8vmin + 0.35rem, 3rem)"
    }
  },
  qrSection: {
    flex: "1 1 0",
    minHeight: 0,
    minWidth: 0,
    width: "100%",
    display: "flex",
    alignItems: "stretch",
    justifyContent: "center"
  },
  qrColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    height: "100%",
    minHeight: 0,
    maxWidth: "100%"
  },
  qrWrap: {
    flex: "1 1 0",
    minHeight: 0,
    minWidth: 0,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    containerType: "size"
  },
  qrPlate: {
    boxSizing: "border-box",
    aspectRatio: "1 / 1",
    width: "min(100%, min(100cqw, 100cqh))",
    maxWidth: "500px",
    maxHeight: "100%",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#fff",
    borderRadius: 12,
    padding: "clamp(6px, 1.2vmin, 14px)",
    boxShadow: "0 6px 20px rgba(0,0,0,0.25)"
  },
  qrImage: {
    display: "block",
    width: "100%",
    height: "100%",
    objectFit: "contain"
  },
  linkText: {
    color: "rgba(255,255,255,0.9)",
    flex: "0 0 auto",
    width: "100%",
    marginTop: "14px",
    textAlign: "center",
    wordBreak: "break-all",
    lineHeight: 1.25,
    "&&": {
      fontSize: "clamp(0.55rem, 1.1vmin + 0.3rem, 1.15rem)"
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Template/Blocks/ItemsQRCode/styles.js